module.exports = __webpack_public_path__ + "img/cloud-saved.54665fc7.svg";